export class CooPayload {
    body: Body = new Body();
}

export class Body {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "SAVEASDRAFT";
    DCLanguage: string = "ENU";
    DCLoginName: string = "";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DCCOOMOBILE";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCCOOMOBILE: ListOfDCCOOMOBILE = new ListOfDCCOOMOBILE();
}

export class ListOfDCCOOMOBILE {
    MEMBER: Member = new Member();
}

export class Member {
    CSN: string = "";
    ListOfSERVICEREQ: ListOfSERVICEREQ = new ListOfSERVICEREQ();
}

export class ListOfSERVICEREQ {
    SERVICEREQ: ServiceReq = new ServiceReq();
}

export class ServiceReq {
    "CSN": string = "";
    "SR Sub Type": string = "";
    "SR Type": string = "";
    "SR Number": string = "";
    "DC Channel": string = "Online";
    "Comments": string = "";
    "Currency": string = "";
    "DC Additional Detail": string = "";
    "DC Address 1": string = "";
    "DC Address 2": string = "";
    "DC Address 3": string = "";
    "DC COO Number": string = "";
    "DC City": string = "";
    "DC Consignee Id": string = "";
    "DC Consignee PO Box Number": string = "";
    "DC Consignee Fax": string = "";
    "DC Consignee Name": string = "";
    "DC Consignee Phone": string = "";
    "DC Consignee Type": string = "";
    "DC Consignee Type eService": string = "";
    "DC Country": string = "";
    "DC Direct Shipment": string = "";
    "DC Shipping From": string = "";
    "DC Exit Point": string = "";
    "DC Expected Departure Date": string = "";
    "DC Exporter Id": string = "";
    "DC Exporter Fax": string = "";
    "DC Exporter Name (Ara)": string = "";
    "DC Exporter Name (Eng)": string = "";
    "DC Exporter Number": string = "";
    "DC Exporter PO Box Number": string = "";
    "DC Exporter Phone": string = "";
    "DC Exporter Type": string = "";
    "DC Final Destination": string = "";
    "DC GSP Authorized Person": string = "";
    "DC Include Shipping Mark": string = "";
    "DC Invoice Amount": string = "";
    "DC Invoice Date": string = "";
    "DC Invoice Number": string = "";
    "DC Language": string = "";
    "DC Member Name (Arabic)": string = "";
    "DC Member Name (English)": string = "";
    "DC No of COO Sets": string = "1";
    "DC No of Copies": string = "1";
    "DC No of Invoice Pages": string = "1";
    "DC No of Invoice Sets": string = "1";
    "DC No of Pack List Pages": string = "1";
    "DC No of Pack List Sets": string = "1";
    "DC Payment Method": string = "Online";
    "DC Port of Discharge": string = "";
    "DC Print COO Product Flg": string = "";
    "DC Shipping Mark Description": string = "";
    "DC Transport By": string = "";
    "DC Vessel Name": string = "";
    "DC eCertificate Flag": string = "";
    "SERVICEREQNUM": string = "";
    "Status": string = "";
    "Sub-Status": string = "";
    "ListOfPRODUCT": ListOfPRODUCT = new ListOfPRODUCT();
    "DC Require Attestation Flag": string = "";
    "DC Print Name English": string = "";
    "DC Print Name Arabic": string = "";
    "DC Doc AI Scan Flag": string = "N";
}
export class ListOfPRODUCT {
    "PRODUCT": Product[] = [];
}
export class Product {
    "DC Seq Of Item": string = "";
    "DC Country of Origin": string = "";
    "DC HS Code": string = "";
    "DC Process Type": string = "";
    "DC Processing Country": string = "";
    "DC Product Arabic Name": string = "";
    "DC Product English Name": string = "";
    "DC Product Id": string = "";
    "DC Quantity": string = "";
    "DC Unit Price": string = "";
    "DC Unit of Measure": string = "";
    "DC Unit of Weight": string = "";
    "DC Weight": string = "";
}
